<template>
  <input type="checkbox" class="app-checkbox large" />
</template>

<script>
  export default {
    name: "CheckBox"
  }
</script>

<style scoped>
  /* Main Classes */
  .app-checkbox{
    border: 0;
    margin: 0;
    padding: 0;
    -webkit-appearance: none;
    outline: none;
  }
  .app-checkbox[type="checkbox"]:before{
    position: relative;
    display: block;
    width: 11px;
    height: 11px;
    border: 2px solid rgba(11, 16, 34, 0.3);
    border-radius: 2px;
    content: "";
    background: #FFF;
  }
  .app-checkbox[type="checkbox"]:after{
    position: relative;
    display: block;
    left: 4px;
    top: -11px;
    width: 7px;
    height: 7px;
    content: "";
  }
  .app-checkbox[type="checkbox"]:checked:after{
    background-color: #CF0920;
  }
  .app-checkbox[type="checkbox"]:disabled:after{
    -webkit-filter: opacity(0.4);
  }
  .app-checkbox[type="checkbox"]:not(:disabled):checked:hover:after{
    background-color: #CF0920;
  }
  .app-checkbox[type="checkbox"]:not(:disabled):hover:after{
    background-color: rgba(207, 9, 32, 0.1);
  }
  .app-checkbox[type="checkbox"]:not(:disabled):hover:before{
    background-color: rgba(207, 9, 32, 0.1);
  }
  /* Large checkboxes */
  .app-checkbox.large{
    height:14px;
    width: 14px;
  }

  .app-checkbox.large[type="checkbox"]:before{
    width: 12px;
    height: 12px;
  }
  .app-checkbox.large[type="checkbox"]:after{
    top: -12px;
    width: 8px;
    height: 8px;
  }
  /* Custom checkbox */
  .app-checkbox.large.custom[type="checkbox"]:checked:after{
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGHRFWHRBdXRob3IAbWluZWNyYWZ0aW5mby5jb23fZidLAAAAk0lEQVQ4y2P4//8/AyUYwcAD+OzN/oMwshjRBoA0Gr8+DcbIhhBlAEyz+qZZ/7WPryHNAGTNMOxpJvo/w0/uP0kGgGwGaZbrKgfTGnLc/0nyAgiDbEY2BCRGdCDCnA2yGeYVog0Aae5MV4c7Gzk6CRqAbDM2w/EaQEgzXgPQnU2SAcTYjNMAYm3GaQCxNuM0gFwMAPUKd8XyBVDcAAAAAElFTkSuQmCC'), linear-gradient(135deg, #B1B6BE 0%,#FFF 100%);
  }
  .app-checkbox.large.custom[type="checkbox"]:not(:disabled):checked:hover:after{
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGHRFWHRBdXRob3IAbWluZWNyYWZ0aW5mby5jb23fZidLAAAAk0lEQVQ4y2P4//8/AyUYwcAD+OzN/oMwshjRBoA0Gr8+DcbIhhBlAEyz+qZZ/7WPryHNAGTNMOxpJvo/w0/uP0kGgGwGaZbrKgfTGnLc/0nyAgiDbEY2BCRGdCDCnA2yGeYVog0Aae5MV4c7Gzk6CRqAbDM2w/EaQEgzXgPQnU2SAcTYjNMAYm3GaQCxNuM0gFwMAPUKd8XyBVDcAAAAAElFTkSuQmCC'), linear-gradient(135deg, #8BB0C2 0%,#FFF 100%);
  }
</style>
